import Swiper from "swiper";
import { Pagination, EffectFade, Autoplay, Navigation } from "swiper/modules";
import { BP_PHONE } from "./common";

// -------------------------------

document.addEventListener("DOMContentLoaded", () => {
  const duplicateSlide = (slider) => {
    const slide = slider.querySelectorAll(".swiper-slide");
    const wrapper = slider.querySelector(".swiper-wrapper");
    if (slide.length) {
      let i = 1;
      let sum = 0;
      let clone;
      sum = [...slide].reduce((sum, el) => {
        return sum + el.offsetWidth;
      }, 0);

      if (sum) {
        while (sum < window.innerWidth * 1.5) {
          slide.forEach((el) => {
            clone = el.cloneNode(true);
            clone.classList.add("clone-slide");
            wrapper.append(clone);
          });
          sum = ++i * sum;
        }
      }
    }
  };

  const removeSlide = (slider) => {
    const cloneSlide = slider.querySelectorAll(".clone-slide");
    cloneSlide.forEach((el) => {
      el.remove();
    });
  };

  // -------------------------------

  const sliderLogo = document.querySelector(".logo-slider-js");

  if (sliderLogo) {
    duplicateSlide(sliderLogo);

    const swiper = new Swiper(".logo-slider-js", {
      modules: [Autoplay],
      speed: 10000,
      slidesPerView: "auto",
      loop: true,
      allowTouchMove: false,
      centeredSlides: true,
      //  loopAdditionalSlides: 20,
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
      },
    });
  }
  // -------------------------------
  const sliderFooterLogo = document.querySelector(".footer-logo-slider-js");
  if (sliderFooterLogo) {
    const isPhone = window.matchMedia(`(max-width: ${BP_PHONE}px)`);
    let swiper;

    const handlerResize = (e) => {
      if (e.matches) {
        duplicateSlide(sliderFooterLogo);

        swiper = new Swiper(".footer-logo-slider-js", {
          modules: [Autoplay],
          speed: 9000,
          slidesPerView: "auto",
          loop: true,
          allowTouchMove: false,
          centeredSlides: true,
          autoplay: {
            delay: 1,
            disableOnInteraction: false,
          },
        });
      } else {
        swiper && swiper.destroy(true, true);
        removeSlide(sliderFooterLogo);
      }
    };

    isPhone.addEventListener("change", (e) => {
      handlerResize(e.target);
    });

    handlerResize(isPhone);
  }
  // -------------------------------
  const sliderComment = document.querySelector(".comment-slider-js");

  if (sliderComment) {
    const swiper = new Swiper(".comment-slider-js", {
      modules: [Pagination, EffectFade, Autoplay],
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });
  }
  // -------------------------------

  const sliderInfo = document.querySelector(".info-slider-js");

  if (sliderInfo) {
    const swiper = new Swiper(".info-slider-js", {
      slidesPerView: 1.35,
      spaceBetween: 35,
      loop: true,
      breakpoints: {
        320: {
          slidesPerView: 1.35,
          spaceBetween: 35,
        },
        768: {
          slidesPerView: 2.25,
          spaceBetween: 35,
        },
        1200: {
          slidesPerView: 2.25,
          spaceBetween: 80,
        },
      },
    });
  }
  // -------------------------------
  const sliderExperiencesGallery = document.querySelector(
    ".experiences-gallery-slider-js"
  );

  if (sliderExperiencesGallery) {
    const swiper = new Swiper(".experiences-gallery-slider-js", {
      modules: [Pagination],
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });
  }
  // -------------------------------

  const sliderEplore = document.querySelector(".explore-slider-js");

  if (sliderEplore) {
    const swiper = new Swiper(".explore-slider-js", {
      // slidesPerView: 3.26,
      modules: [Navigation],
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      loop: true,
      breakpoints: {
        320: {
          slidesPerView: 1.25,
        },
        768: {
          slidesPerView: 2.25,
        },
        1024: {
          slidesPerView: 3.26,
        },
      },
    });
  }

  const sliderArticle = document.querySelector(".article-slider-js");

  if (sliderArticle) {
    const swiper = new Swiper(".article-slider-js", {
      // slidesPerView: 3.26,
      modules: [Navigation],
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      loop: true,
      breakpoints: {
        320: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  }

  const sliderComments = document.querySelector(".comments-slider-js");

  if (sliderComments) {
    const swiper = new Swiper(".comments-slider-js", {
      slidesPerView: 1,
      loop: true,
      modules: [Pagination, Autoplay],
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });
  }
});
